import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ open, onClick }) => {
  if (!open) {
    return null;
  }
  const overlayClass = 'fixed inset-0 bg-black bg-opacity-40 z-1400';
  return (
    <div className={overlayClass} onClick={onClick} role="presentation" />
  );
};

Overlay.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Overlay;
